import { FC, useEffect, useState } from "react";
import { Button, Result } from "antd";
import { DisconnectOutlined, YoutubeFilled } from "@ant-design/icons";
import { captureException } from "@sentry/react";
import useHttpClient from "../hooks/useHttpClient";
import { AxiosResponse } from "axios";

interface YoutubeConnectProps {
  permissions: string[];
  title?: string;
  subTitle?: string;
}

interface OAuthPermissionResponse {
  data: {
    redirectUrl: string;
  };
}

const YoutubeConnect: FC<YoutubeConnectProps> = ({
  permissions,
  title = "این سرویس برای اکانت شما فعال نشده است",
  subTitle = "جهت فعال‌سازی این سرویس روی دکمه زیر کلیک کنید.",
}) => {
  const httpClient = useHttpClient();
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    httpClient
      .post<OAuthPermissionResponse>("/auth/oauth2/permission", {
        permissions: permissions.join(","),
        redirectUri: `${window.location.origin}/auth/callback`,
      })
      .then((response: AxiosResponse<OAuthPermissionResponse>) => {
        const redirectUrl: string = response.data.data.redirectUrl;
        setUrl(redirectUrl);
      })
      .catch(captureException);
  }, [httpClient, permissions]);

  return (
    <Result
      icon={<DisconnectOutlined />}
      status="error"
      title={title}
      subTitle={subTitle}
      extra={[
        <Button
          href={url || undefined}
          icon={<YoutubeFilled style={{ fontSize: 25 }} />}
          size="large"
          style={{ backgroundColor: "#FF0000" }}
          type="primary"
          disabled={!url}
        >
          اتصال اکانت
        </Button>,
      ]}
    />
  );
};

export default YoutubeConnect;
